/* eslint-disable @typescript-eslint/no-explicit-any */
import produce from 'immer';
import {
  GET_CUS_RECONCILIATION_DONE,
  GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_COUNT_DONE,
  GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_DONE,
  GET_MONEY_STATISTICS_DONE,
} from './constant';

export type QuanLyTienhangState = {
  listStatisticMoney: any;
  listDongTien: any;
  listBangKe: any;
  countBangKe: any;
};

const initState: QuanLyTienhangState = {
  listStatisticMoney: [],
  listDongTien: [],
  listBangKe: [],
  countBangKe: 0
};

export const QuanLyTienHangReducer = (
  state = initState,
  action: ActionType,
): QuanLyTienhangState => {
  return produce(
    state,
    (draftState: QuanLyTienhangState): QuanLyTienhangState => {
      switch (action.type) {
        case GET_MONEY_STATISTICS_DONE:
          draftState.listStatisticMoney = action.payload;
          return draftState;
        case GET_CUS_RECONCILIATION_DONE:
          draftState.listDongTien = action.payload;
          return draftState;
        case GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_DONE:
          draftState.listBangKe = action.payload;
          return draftState;
        case GET_CUS_RECONCILIATION_PAYMENT_STATEMENT_COUNT_DONE:
          draftState.countBangKe = action.payload;
          return draftState;
        default:
          return draftState;
      }
    },
  );
};
